import { useContext } from "react";
import { MapContext } from "../../MapContext";
import { Map } from "ol";

export function useMap(): Map {
  const map = useContext(MapContext);
  if (!map) {
    throw new Error(
      "useMap must be used within a <MapContainer> or <SyncMap>."
    );
  }
  return map;
}
